import { render } from "./AddSlot.vue?vue&type=template&id=586264fa"
import script from "./AddSlot.vue?vue&type=script&lang=js"
export * from "./AddSlot.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__